import { FC, useEffect, useState } from 'react';
import DropDownButtonLegacy from 'common/components/drop-downs/legacy/dropDownButtonLegacy';
import { useDispatch, useSelector } from 'react-redux';
import { ChartRoutes } from './constants/chartRoutes';
import { selectChartType, getChartOptions } from '../chartOptionsSlice';
import { RootState } from 'app/store';
import SimpleButtonContainContent from 'common/components/drop-downs/legacy/simpleDropDownButtonContainerContent';
import {
  doRoutesNeedToBeUpdated,
  setSelectedDropDownItemAsActive
} from 'common/components/drop-downs/legacy/dropDownUtils';

const ChartTypeButton: FC<{
  chartId: string;
  defaultType: string;
}> = ({ chartId, defaultType }: { chartId: string; defaultType: string }) => {
  const dispatch = useDispatch();
  const [chartRoutes, setChartRoutes] = useState(ChartRoutes);
  const { selectedChartType } = useSelector((state: RootState) =>
    getChartOptions(state, chartId)
  );

  useEffect(() => {
    if (chartId === undefined || chartId === '') {
      throw new Error('ChartId is undefined, you must pass a chartId');
    }

    if (selectedChartType === undefined) {
      dispatch(selectChartType({ chartId, selectedChartType: defaultType }));
    } else if (doRoutesNeedToBeUpdated(chartRoutes, selectedChartType)) {
      setChartRoutes(
        setSelectedDropDownItemAsActive(chartRoutes, selectedChartType)
      );
    }
  }, [chartId, chartRoutes, defaultType, dispatch, selectedChartType]);

  return (
    <DropDownButtonLegacy
      dropDownItems={chartRoutes}
      selectDropDownItem={(label) =>
        dispatch(selectChartType({ chartId, selectedChartType: label }))
      }
    >
      <SimpleButtonContainContent
        dropdownLabel="Chart Type"
        additionalContainerStyling="bg-white rounded border border-neutral-200"
      />
    </DropDownButtonLegacy>
  );
};

export default ChartTypeButton;
